import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { OperatoriProiecteService } from '../operatori-proiecte.service';
import { Observable, finalize, map } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-update-functie-operatori-proiecte',
    templateUrl: './update-functie-operatori-proiecte.component.html',
    styleUrls: ['./update-functie-operatori-proiecte.component.scss']
})
export class UpdateFunctieOperatoriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;
    functiiActive$: Observable<any> = new Observable();

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        functie_id: new FormControl(-1, [Validators.required, Validators.min(0)]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<UpdateFunctieOperatoriProiecteComponent>,
        private notificationService: NotificationService,
        private operatoriProiecteService: OperatoriProiecteService,
        private commonService: CommonService,
    ) {
        this.loadFunctiiActive();
        this.loadFunctieOperator();
    }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadFunctiiActive() {
        this.isLoading = true;

        this.functiiActive$ = this.commonService.getFunctiiActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        )
    }

    loadFunctieOperator() {
        this.isLoading = true;
        this.operatoriProiecteService
            .getFunctieOperator(this.data.id_user)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (results: any) => {
                    this.form.patchValue({
                        functie_id: results.data.user_functie_id
                    })
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    updateFunctieOperator() {
        this.isLoading = true;
        this.operatoriProiecteService
            .updateFunctieOperator(this.data.id_user, this.form.value)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
